import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { buildPayload } from "./caseQuizLogic";
import { routedThankYou } from "@/lib/routedBuyer";

const CELEBRATE_MS = 1700;
const IDLE = { submitting: false, error: "", celebrate: false, previewOnly: false };

function thankYouQuery(vertical, extra, data = null) {
  return new URLSearchParams({
    ...extra,
    vertical: vertical.slug,
    experience: "case_quiz",
    ...routedThankYou(vertical, data),
    ...(vertical.funnelSlug ? { funnel: vertical.funnelSlug } : {}),
  }).toString();
}

export function useCaseSubmit({ vertical, previewSurface, demo }) {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [st, setSt] = useState(IDLE);
  const timer = useRef(null);
  useEffect(() => () => { clearTimeout(timer.current); }, []);

  const celebrateThen = (query, previewOnly = false) => {
    setSt({ ...IDLE, celebrate: true, previewOnly });
    if (query) timer.current = setTimeout(() => nav(`/lp/thank-you?${query}`), CELEBRATE_MS);
  };

  const submit = async (input) => {
    if (previewSurface) {
      if (demo && vertical.customSlug) celebrateThen(thankYouQuery(vertical, { demo }));
      else celebrateThen(null, true);
      return;
    }
    setSt({ ...IDLE, submitting: true });
    input.session?.trackEvent("submit_click", { variant: "case_quiz" });
    try {
      const { data } = await api.post("/public/landing/lead", buildPayload({ ...input, vertical, params }));
      celebrateThen(thankYouQuery(vertical, { lead_id: data.id, ...(data.is_test ? { test: "1" } : {}) }, data));
    } catch (err) {
      const msg = err?.response?.data?.detail;
      setSt({ ...IDLE, error: typeof msg === "string" ? msg : "Something went wrong — please try again." });
    }
  };

  return { ...st, submit };
}
